// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'es6-promise/auto'
import Vue from 'vue'
import router from '@/router'
import store from '@/store/index'
// import ajax from '@/libs/ajax'
import '@/assets/css/reset.css'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
Vue.config.productionTip = false
import { wxSetTitle } from '@/libs/title'
import api from './http/index'

import VueImg from 'v-img';

Vue.use(api)
Vue.use(VueImg)
Vue.use(elementUI)
// Vue.use(ajax)
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
        wxSetTitle(to.meta.title)
    }
    next()
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<router-view></router-view>'
})



// WEBPACK FOOTER //
// ./src/main.js